import React, { Component } from "react";
import axios from "axios";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { Public } from "@material-ui/icons";
import { FormattedDate, useIntl } from "react-intl";
import { CurrencyDisplay, CurrencySymbol } from "../../common/CurrencyDisplay";
import { REASON_CODE } from "../../constants/ApplicationConstants";
import Moment from "moment";
let date = new Date();

function getDifferenceInDays(DueDate: any, DataDiff: any, paymentDue: any) {
  const date1 = new Date(DueDate);
  if (paymentDue > 0) {
      const diff = Number(DataDiff ?? 0);
    if (date > date1) {
       return "-" + diff;
    } else {
       return diff;;
    }
  } else {
    return null;
  }
}
function getDocumentNumber(p) {
  if (p.billing_document_number && p.billing_document_number !== "0") {
    return p.billing_document_number;
  }
  return p.document_number_finance || "";
}
function isCredit(open_amount: any): boolean {
  return typeof open_amount !== "undefined" && open_amount < 0;
}
function csvStatusFormatter(
  clearing_date: any,
  item_is_a_payment: any,
  open_amount: any,
  intl:any
) {
  
   let f = id => intl.formatMessage({ id: id });
  if (isCredit(open_amount)) {
    return f("invoice_table.credit");
  }
  if ((clearing_date ?? "" ) || clearing_date !== undefined) {
    return f("invoice_table.paid");
  }
  if (item_is_a_payment === "X" || item_is_a_payment !== undefined) {
    return f("invoice_table.paid");
  }
  return f("invoice_table.open");
}
function ExportExcel(props) {
  const intl = useIntl();
  const f = (id) => intl.formatMessage({ id: id });
  // Check if StatementID exists in data
  const hasStatementId = props.data.invoicesData.some((p) => p.statementId);
  return (
    <div>
       <div>
         <meta charSet="UTF-8" />
       </div>
      <table id="Invoice" className="table" style={{ display: "none" }}>
        <thead>
          <tr>
            <th>{props.data.columnsData[0].text}</th> {/* Status */}
            <th>{props.data.columnsData[1].text}</th> {/* Ref # */}
            <th>{props.data.columnsData[2].text}</th> {/* Doc # */}
            {hasStatementId && <th>{props.data.columnsData[3].text}</th>}{" "}
            {/* Statement ID */}
            <th>{props.data.columnsData[4].text}</th> {/* Date */}
            <th>{props.data.columnsData[5].text}</th> {/* Total */}
            <th>{props.data.columnsData[6].text}</th> {/* Paid */}
            <th>{props.data.columnsData[7].text}</th> {/* Open */}
            <th>{props.data.columnsData[8].text}</th> {/* Due */}
            <th>{props.data.columnsData[9].text}</th> {/* Days Till Due */}
            <th>{props.data.columnsData[11].text}</th> {/* Account */}
          </tr>
        </thead>
        <tbody>
          {props.data.invoicesData.map((p, index) => {
            return (
              <tr key={index}>
                <td>
                  {csvStatusFormatter(
                    p.clearing_date,
                    p.item_is_a_payment,
                    p.open_amount,
                    intl
                  )}
                </td>
                <td>{p.reference_number}</td>
                <td>{getDocumentNumber(p)}</td>
                {hasStatementId && <td>{p.statementId || ""}</td>}
                <td>{p.document_date}</td>
                <td>{p.total_amount}</td>
                <td>{p.paid_amount}</td>
                <td>{p.open_amount}</td>
                <td>{isCredit(p.open_amount) ? "" : p.due_date}</td>
                <td>
                  {getDifferenceInDays(
                    p.due_date,
                    p.days_in_arrears,
                    p.open_amount
                  )}
                </td>
                <td>{p.soldto_number}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <div>
        <ReactHTMLTableToExcel
          className="dropdown-item !important"
          table="Invoice"
          filename="InvoiceExport"
          sheet="Sheet"
          buttonText={f("invoice_export.all_excel")}
        />
      </div>
    </div>
  );
}

export default ExportExcel;
